import template from "./user-modal.html";
import "./user-modal.less";
import tabbedModal from "../../modals/tabbed-modal";
import userModalTabs from "./tabs";
import { EVENT_LOGOUT } from "../../../constants";
import { FORMS_REQUEST } from "../../../routes";

//user-modal
export function controller(
	eventBus,
	$scope,
	appState,
	api,
	$location
) {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = handleClose;
	ctrl.reload = reload;
	ctrl.setUser = setUser;

	function isSyncUrl() {
		return ctrl.resolve.syncUrl !== false;
	}

	ctrl.unprocessedRequests = [];
	ctrl.showEntityAssignmentTab = false;
	ctrl.showRequestsTab = false;

	function onInit() {
		ctrl.user = ctrl.resolve.user;
		ctrl.permissions = appState.permissions.Administration.User;
		ctrl.form = appState.forms.selected;

		if(ctrl.user) {
			ctrl.user.UserName = ctrl.user.UserName || ctrl.user.Username; // hack until API picks a standard
			if(!ctrl.permissions.IsDisabled && ctrl.permissions.Actions.CanPermit) {
				ctrl.showEntityAssignmentTab = true;
			}

			api.get(FORMS_REQUEST(ctrl.form.Id, ctrl.user.Id))
				.then(requests => {
					const unprocessedRequests = requests.filter(r => r.IsProcessed !== true);
					ctrl.unprocessedRequests = unprocessedRequests;

					if(unprocessedRequests.length > 0) {
						ctrl.showRequestsTab = true;
					}
				});
		}

		eventBus.register(EVENT_LOGOUT, () => { handleClose(); }, $scope);
	}

	function reload() {
		!!ctrl.getUsers && ctrl.getUsers();
	}

	function setUser(obj) {
		if(obj.user.Username) {
			obj.user.UserName = obj.user.Username; // hack until API picks a standard
		}
		ctrl.user = obj.user;

		// After creating a user, update URL from action=add to id=<newId>
		if(isSyncUrl() && obj.user.Id) {
			$location.search("action", null)
				.search("id", String(obj.user.Id))
				.replace();
		}

		ctrl.showEntityAssignmentTab = true;
	}

	function handleClose() {
		reload();
		ctrl.modalInstance.close();
	}
}

export default angular
	.module("vesl.components.user-modal", [tabbedModal, userModalTabs])
	.component("userModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			getUsers: "&"
		}
	}).name;
